import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { clientsApi } from "../../../services/api";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box } from "@mui/material";
import DangerBaseButton from "../../../main/components/DangerBaseButton";

type ClientDetailsFooterProps = {
  clientId: string;
};

export function ClientDetailsFooter(props: ClientDetailsFooterProps) {
  const { clientId } = props;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [openDeleteErrorModal, setOpenDeleteErrorModal] = useState(false);
  const [openDeleteSuccessModal, setOpenDeleteSuccessModal] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          flexDirection: "column",
          display: "flex",
          alignItems: { xs: "center", md: "end" },
          height: "75px",
          justifyContent: "space-between",
        }}
      >
        <DangerBaseButton
          startIcon={<DeleteIcon />}
          title="Deletar Cliente"
          onClick={() => setShowDeleteModal(true)}
        />
      </Box>
      <ConfirmationModal
        contentText="Deseja confirmar a exclusão do cliente?"
        title="Excluir Cliente"
        open={showDeleteModal}
        setOpen={setShowDeleteModal}
        onConfirm={async () => {
          await clientsApi.deleteClient(clientId);
        }}
        setOpenErrorModal={setOpenDeleteErrorModal}
        setOpenSuccessModal={setOpenDeleteSuccessModal}
        confirmationButtonColor="error"
      />
      <ActionAlert
        message="O client foi deletado com sucesso!"
        severity="success"
        open={openDeleteSuccessModal}
        setOpen={setOpenDeleteSuccessModal}
        onClose={() => {
          setShowDeleteModal(false);
          navigate("/clients");
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao deletar o cliente!"
        severity="error"
        open={openDeleteErrorModal}
        setOpen={setOpenDeleteErrorModal}
        onClose={() => {
          setShowDeleteModal(false);
        }}
      />
      {/* <SuccessModal
        open={openDeleteSuccessModal}
        setOpen={setOpenDeleteSuccessModal}
        title="Cliente deletado com Sucesso!"
        contentText="O client foi deletado com sucesso!"
        onClose={() => {
          setShowDeleteModal(false);
          navigate("/clients");
        }}
      />
      <ErrorModal
        open={openDeleteErrorModal}
        setOpen={setOpenDeleteErrorModal}
        title="Erro ao deletar o Cliente"
        contentText="Ocorreu um erro ao deletar o cliente!"
        onClose={() => {
          setShowDeleteModal(false);
        }}
      /> */}
    </>
  );
}
